import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ activeCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', name: 'Semua Produk', icon: 'Grid3x3' },

    // ===== APPAREL =====
    { id: 'jacket', name: 'Jaket', icon: 'Shirt' },
    { id: 'shirt', name: 'Kaos & Kemeja', icon: 'Tshirt' },
    { id: 'vest', name: 'Vest', icon: 'Layers' },
    { id: 'jersey', name: 'Jersey', icon: 'Activity' },

    // ===== AKSESORIS =====
    { id: 'bag', name: 'Tas', icon: 'Briefcase' },
    { id: 'gloves', name: 'Sarung Tangan', icon: 'Hand' },
    { id: 'cap', name: 'Topi', icon: 'Hat' },
    { id: 'keychain', name: 'Gantungan Kunci', icon: 'Key' },
    { id: 'tumbler', name: 'Tumbler', icon: 'CupSoda' },
    { id: 'wallet', name: 'Dompet', icon: 'Wallet' },
    { id: 'umbrella', name: 'Payung', icon: 'Umbrella' },
    { id: 'headwear', name: 'Headwear', icon: 'Bandage' },
    { id: 'arm-cover', name: 'Arm Cover', icon: 'Shield' },
    { id: 'key-cover', name: 'Cover Smart Key', icon: 'Lock' },
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
      <h3 className="text-lg font-heading font-bold text-foreground mb-4 flex items-center space-x-2">
        <Icon name="Filter" size={20} color="var(--color-primary)" />
        <span>Kategori</span>
      </h3>

      <div className="space-y-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`w-full flex items-center space-x-3 p-3 rounded-lg transition-all duration-300 ${
              activeCategory === category.id
                ? 'bg-primary text-primary-foreground shadow-honda-subtle'
                : 'bg-muted text-foreground hover:bg-primary/10 hover:text-primary'
            }`}
          >
            <Icon
              name={category.icon}
              size={18}
              color={
                activeCategory === category.id
                  ? 'white'
                  : 'var(--color-foreground)'
              }
            />
            <span className="font-heading font-semibold text-sm">
              {category.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;
